import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "text-base font-medium leading-6 text-(--colors-text-heading) dark:text-white" };
const _hoisted_2 = { class: "space-y-5" };
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" };
const _hoisted_4 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" };
const _hoisted_5 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Button, Modal } from "@eudonet/opal";
import { useProfileStore } from "@/modules/settings/public";
import { formatDateTime } from "@/shared/utils/date-formatting";
import PropertyRow from "@/shared/components/PropertyRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationPropertiesModal',
    props: {
        modelValue: { type: Boolean },
        properties: {},
        legalName: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t, locale } = useI18n();
        const profileStore = useProfileStore();
        // Status values for which we surface the archiving reason row. Mirrors the
        // OPHUB enum exposed in the layout custom-fields block.
        const ARCHIVED_STATUSES = new Set(["Inactive", "InLiquidation", "Closed"]);
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit("update:modelValue", value),
        });
        const showArchivingReason = computed(() => !!props.properties.archivingReason ||
            (props.properties.status !== null && ARCHIVED_STATUSES.has(props.properties.status)));
        const statusLabel = computed(() => {
            const status = props.properties.status;
            return status ? t(`organisation.status.${status}`) : null;
        });
        const formattedCreatedAt = computed(() => formatInstant(props.properties.createdAt));
        const formattedUpdatedAt = computed(() => formatInstant(props.properties.updatedAt));
        function formatInstant(value) {
            if (!value)
                return null;
            return formatDateTime(value, locale.value, profileStore.profile?.dateFormat, profileStore.profile?.timeFormat, profileStore.profile?.timeZone ?? undefined);
        }
        function close() {
            emit("update:modelValue", false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                size: "md",
                "header-position": "left",
                "footer-position": "right",
                "data-testid": "organisation-properties-modal"
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("organisation.detail.properties.title")), 1 /* TEXT */)
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _unref(t)('organisation.detail.properties.close'),
                        "data-testid": "organisation-properties-modal-close",
                        onClick: close
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("dl", _hoisted_2, [
                        _createVNode(PropertyRow, {
                            label: _unref(t)('organisation.detail.properties.organisation'),
                            value: __props.legalName,
                            variant: "link"
                        }, null, 8 /* PROPS */, ["label", "value"]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(PropertyRow, {
                                label: _unref(t)('organisation.detail.properties.geolocalisation'),
                                value: __props.properties.geolocalisation
                            }, null, 8 /* PROPS */, ["label", "value"]),
                            _createVNode(PropertyRow, {
                                label: _unref(t)('organisation.detail.properties.status'),
                                value: statusLabel.value,
                                variant: "shell"
                            }, null, 8 /* PROPS */, ["label", "value"])
                        ]),
                        (showArchivingReason.value)
                            ? (_openBlock(), _createBlock(PropertyRow, {
                                key: 0,
                                label: _unref(t)('organisation.detail.properties.archivingReason'),
                                value: __props.properties.archivingReason
                            }, null, 8 /* PROPS */, ["label", "value"]))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(PropertyRow, {
                                label: _unref(t)('organisation.detail.properties.createdAt'),
                                value: formattedCreatedAt.value,
                                variant: "shell"
                            }, null, 8 /* PROPS */, ["label", "value"]),
                            _createVNode(PropertyRow, {
                                label: _unref(t)('organisation.detail.properties.createdBy'),
                                value: __props.properties.createdBy?.displayName ?? null,
                                variant: "shell"
                            }, null, 8 /* PROPS */, ["label", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(PropertyRow, {
                                label: _unref(t)('organisation.detail.properties.updatedAt'),
                                value: formattedUpdatedAt.value,
                                variant: "shell"
                            }, null, 8 /* PROPS */, ["label", "value"]),
                            _createVNode(PropertyRow, {
                                label: _unref(t)('organisation.detail.properties.updatedBy'),
                                value: __props.properties.updatedBy?.displayName ?? null,
                                variant: "shell"
                            }, null, 8 /* PROPS */, ["label", "value"])
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
